import { render, staticRenderFns } from "./albumManagement.vue?vue&type=template&id=55687775&"
import script from "./albumManagement.vue?vue&type=script&lang=js&"
export * from "./albumManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports